export const PROJECT_LIST = "/api/view/project/list";
export const CREATE_MODULE = "/api/vault/resource/module/create";
export const FETCH_MODULE_LIST = "/api/vault/resource/module/list";
export const MODULE_BASIC_DETAILS = "/api/resource/module/basic";
export const UPDATE_MODULE_BASIC_DETAILS = "/api/vault/resource/module/basic";
export const FETCH_MODULE_TAG_LIST = "/api/tag/list";
export const XR_MODULE_TASK_SCENARIO = "/api/vault/resource/module/tasks";
export const UPLOAD_ASSET = "/api/vault/resource/asset/upload";
export const ASSEST_CREATE_VERSION = "/api/vault/resource/asset/create/version";
export const RESOURCE_ASSEST_LIST_VERSION = "/api/vault/resource/asset/list/versions";
